/**
 * version.ts — the application's version, shown at the foot of the account menu as `v{MAJOR}.{MINOR}`.
 *
 * The same construction as `fintro` and `jeeves-ai-assistant`, deliberately: three applications in one
 * business unit that answer "what are you running?" three different ways is three things to explain to
 * the same person. Their file is `web/src/version.ts`, their hook bumps `MINOR`, and so do these.
 *
 * MINOR is bumped by +1 automatically on every commit whose staged changes touch anything other than this
 * file, by `.githooks/pre-commit` (enabled by `npm install` through the `prepare` script, or once by hand
 * with `git config core.hooksPath .githooks`). MAJOR is reserved for major changes and is only ever
 * bumped BY HAND: raise MAJOR and reset MINOR to 0 in the same commit. The hook never touches MAJOR.
 *
 * Committed in source rather than derived at build time, and that is the load-bearing decision. The
 * Docker build copies `web/` and has no `.git` to read; the production build runs from a checkout that
 * does, and a version that existed in one and not the other would be "unknown" exactly where somebody
 * needed it. A number in a file is available to every build there will ever be.
 *
 * ⚠️ DO NOT EDIT `MINOR` BY HAND, and do not reformat these two lines. The hook's `sed` matches
 * `MAJOR = <n>` and `MINOR = <n>` literally; `test/version.test.ts` asserts that this file and that
 * expression still agree, because the failure otherwise is silent — the hook simply stops bumping and
 * nothing anywhere reports it.
 */
export const MAJOR = 0;
export const MINOR = 36;

/** The version string the account menu shows, e.g. "v0.1". */
export const VERSION = `v${MAJOR}.${MINOR}`;
